import { render, staticRenderFns } from "./index-task-management.vue?vue&type=template&id=5ff1c83d&"
import script from "./index-task-management.vue?vue&type=script&lang=js&"
export * from "./index-task-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports